export default __webpack_public_path__ + "static/media/6.8697a73d.pdf";